<template>
  <div class="container">
    <div class="content">
      
      <div class="entity-header"> 
        <div class="entity-title">{{ $t('tournament.details') }}<font-awesome-icon icon="cog" class="w3-right" /></div>
        <div class="entity-details"> {{ tournament.name }} {{ tournament.edition }}</div>
        <div class="tab-nav">
          <div @click.prevent="setActiveTab('GeneralInformation')" class="tab" :class="{ active: isActiveTab('GeneralInformation') }">{{ $t('tournament.generalInformation') }}</div> 
          <div @click.prevent="setActiveTab('EntryForm')" class="tab" :class="{ active: isActiveTab('EntryForm') }">{{ $t('tournaments.entryForm') }}</div> 
          <div @click.prevent="setActiveTab('Pairing')" class="tab" :class="{ active: isActiveTab('Pairing') }">{{ $t('tournament.pairingAndScoring') }}</div> 
          <div @click.prevent="setActiveTab('Management')" class="tab" :class="{ active: isActiveTab('Management') }">{{ $t('tournament.management') }}</div> 
        </div>
      </div>
      
<!-- Report download status modal -->      
      <transition name="modal-fade" v-if="showReportDownloadStatus">
        <div class="modal-backdrop">
          <div class="modal">
            <section class="modal-body">
              <slot name="body">
                <div class="importStatus">
                  <header>
                    <h4>Report Download status</h4>
                  </header> 
                  <div class="content">
                    <label>
                      report status
                    </label>
                    <div class="w3-panel errorBox w3-round">
                      {{ currentReportDownloadStatus }}
                      <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" />
                    </div>
                  </div>
                </div>
              </slot>
            </section>
          </div>
        </div>
      </transition>

<!-- General information -->      
      <section v-if="isActiveTab('GeneralInformation')" class="section"> 
        <label>
          {{ $t('tournaments.name') }} *
          <input v-model="tournament.name" class="theme-input" type="text" :placeholder="$t('tournaments.name')">
        </label>
        <label>
          {{ $t('tournament.edition') }}
          <input v-model="tournament.edition" class="theme-input" type="text" :placeholder="$t('tournament.edition')">
        </label>
        <label>
          {{ $t('tournament.organizer') }} 
          <select v-model="_tournamentOrganizer">
            <option value="0">{{$t('tournament.organisingMyself')}}</option>
            <option v-for="club in organizerClubs" v-bind:key="club.clubId" :value="club.clubId">{{club.name}}</option>
          </select>
        </label>
        <label>
          {{ $t('tournament.location') }}
          <input v-model="tournament.location" class="theme-input" type="text" :placeholder=" $t('tournament.location')">
        </label>
          {{ $t('tournament.from') }}
        <datepicker-lite :locale="locale" :value-attr="_startDate" @value-changed="startDateSelection" >
        </datepicker-lite>
          {{ $t('tournament.until') }}
        <datepicker-lite :value-attr="_endDate" :locale="locale" @value-changed="endDateSelection">
        </datepicker-lite>
        <label>
          {{ $t('tournament.pairingSystem') }} *
          <select v-model="_tournamentType">
            <option class="placeholder" value="-1" disabled selected hidden>{{ $t('tournament.selectType') }}</option>
            <option value="1">zwitsers</option>
            <option value="2">keizer</option>
            <option value="3">volledige competitie</option>
          </select>
        </label>
        <label>
          {{ $t('tournament.tempo') }}
          <select v-model="_timeControl">
            <option value="1">KNSB (120m + 30s / 40, 60m + 30s</option>
            <option value="2">SOS (100m + 10s)</option>
            <option value="3">Standard Rapid (10m + 0s)</option>
            <option value="4">Standard Blitz (5m + 0s)</option>
            <option value="5">Standard Online Blitz (3m + 2s)</option>
            <option value="6">Other classic</option>
            <option value="7">Other Rapid</option>
            <option value="8">Other Blitz</option>
          </select>
        </label>
        <label>
          {{ $t('tournament.description') }}<br/>
          <textarea v-model="tournament.description" :placeholder="$t('tournament.extraNotes')"></textarea>
        </label>
  <!-- future feature
        <label>
          {{ $t('tournament.entry') }}
          <select v-model="tournament.openTo" name="entry" id="entry">
            <option>open for everyone</option>
            <option>clubmembers only</option>
            <option>invitees only</option>
          </select>
        </label>
  -->
      </section>

<!-- Pairing and scoring -->      
      <section v-if="isActiveTab('Pairing')" class="section"> 
        <div v-if="tournament.tournamentId==null">
          Deze gegevens komen pas beschikbaar nadat het toernooi is opgeslagen.
        </div> 
        <div v-if="tournament.tournamentId!=null">
          <!-- Currently, only Keizer... -->
          <h4 class="groupheader">{{$t('tournament.pairing')}}</h4>
          <table class="settingsTable">
            <tr v-for="setting in settings" v-bind:key="setting.settingId" :setting="setting">
              <td>{{setting.name}}</td>
              <td class="lastCol"><input v-model="setting.value" v-on:change="settingsChanged()" inputmode="numeric" pattern="[0-9]*" class="theme-input nr" type="text"></td>
            </tr>
          </table>
          <h4 class="groupheader">{{$t('tournament.scoring')}}</h4>
          <table class="settingsTable">
            <tr v-for="score in scores" v-bind:key="score.scoreId" :score="score">
              <td class="expandCol">{{score.name}}</td>
              <td class="lastCol"><input v-model="score.value" v-on:change="scoresChanged()" inputmode="decimal" pattern="[0-9]*" class="theme-input nr" type="text"></td>
            </tr>
          </table>
        </div>
      </section>

<!-- Management -->      
      <section v-if="isActiveTab('Management')" class="section"> 
        <div v-if="tournament.tournamentId==null">
          Deze gegevens komen pas beschikbaar nadat het toernooi is opgeslagen.
        </div> 
        <div v-if="tournament.tournamentId!=null">
          <h2>{{$t('tournament.managers')}}</h2>
          {{$t('tournament.managersText')}}
          <table class="result-table"><tbody>
            <tr class="result-row" v-for="manager in tournament.managers" v-bind:key="manager.managerId" :manager="manager">
  <!--            <td>{{manager.managerId}}</td> -->
              <td >{{manager.person.name}}</td>
              <td class="result-cell-last"><button class="grid-btn" href="#" title="remove this manager" v-if="managerIsNotCurrentUser(manager.personId)" @click="removeTournamentManager(manager.managerId)"><font-awesome-icon icon="trash" class="grid-icon"/></button></td>
            </tr>
          </tbody></table>
          <div class="sectionButtons">
            <button class="button-default" @click="selectManager">{{ $t('tournament.selectManager.add') }}</button>
          </div>
          <transition name="modal-fade" v-if="_showManagerAddition">
            <div class="modal-backdrop">
              <div class="modal">
                <section class="modal-body">
                  <slot name="body">
                    <select-manager 
                      v-on:cancel="handleManagerModalResultCancel()" 
                      v-on:ok="handleManagerModalResultOK" ></select-manager>
                  </slot>
                </section>
              </div>
            </div>
          </transition>

          <h2>{{$t('tournament.ratingReport')}}</h2>
          <p>{{$t('tournament.reportText')}}</p>
          <label>
            {{ $t('tournament.fromRound') }} 
            <select v-model="firstReportRound">
              <option class="placeholder" value="-1" disabled selected hidden>{{ $t('tournament.selectFromRound') }}</option>
              <option v-for="round in rounds"
                                  :key="round.roundId" 
                                  :round = "round"
                                  :value = "round.number">{{round.number}}. {{showDate(round.date)}}</option>
            </select>
          </label>
          <label>
            {{ $t('tournament.untilRound') }} 
            <select v-model="lastReportRound">
              <option class="placeholder" value="-1" disabled selected hidden>{{ $t('tournament.selectUntilRound') }}</option>
              <option v-for="round in rounds"
                                  :key="round.roundId" 
                                  :round = "round"
                                  :value = "round.number">{{round.number}}. {{showDate(round.date)}}</option>
            </select>
          </label>

          <div class="sectionButtons">
            <button class="button-default" @click="downloadReport">{{ $t('app.actions.download') }}</button>
          </div>

          <h2>{{$t('tournament.notifications')}}</h2>
          <p>
            Participants will automatically get two sorts of notifcations:<br/>
              1. After pairing, when the arbiter presses the button [V Finalize round]<br/> 
              2. After the round is complete, when the arbiter presses the button [round complete]<br/>
          </p>
          <h2>{{$t('tournament.resultUpload')}}</h2>
          <p>{{$t('tournament.uploadExplanation')}}</p>
          <label>
            {{ $t('tournament.sftpKeyfile') }} 
            <div class="row">
              <input class="theme-input" type="file" :placeholder="$t('tournament.sftpKeyfile')" @change="onFilePicked">
              <button class="button-tight" @click="uploadKeyfile">{{ $t('tournament.upload') }}</button>
            </div>
          </label>

        </div>

      </section>

      <div class="buttons">
        <button class="button-default" @click="cancel">{{ $t('app.actions.cancel') }}</button>
        <button v-if="!_creatingMode" class="button-default" @click="save">{{ $t('app.actions.save') }}</button>
        <button v-if="_creatingMode" class="button-default" @click="save">{{ $t('app.actions.saveContinue') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import DatepickerLite from 'vue3-datepicker-lite';
import moment from 'moment';
import SelectManager from "../tournaments/SelectManager.vue";

const apiName = 'api';
const path = '/tournament/';
const myInit = { 
  response: false, 
};

export default {
  name: 'EditTournamentDetails',
  components: {DatepickerLite, SelectManager},
  data: function () {
    return {  
      activeTabItem: "GeneralInformation",
      currentReportDownloadStatus: "",
      files: null,
      startDateString: "",
      firstReportRound: -1,
      firstTime: true,
      interval: null,
      lastReportRound: -1,
      manager: {personId: -1},
      organizerClubs: [],
      reportDownloading: false,
      rounds: [],
      selectedPersonId: -1,
      settings: [],
      settingsDirty: false,
      scores: [],
      scoresDirty: false,
      showingManagerAddition: false,
      showingReportDownloadStatus: false,
      tournament: {groups: []},
      locale: {
        format: "DD-MM-YYYY",
        weekday: ["Z", "M", "D", "W", "D", "V", "Z"],
        todayBtn: "vandaag",
        clearBtn: "verwijderen",
        closeBtn: "sluiten"
      }
    }
  },
  beforeMount() {
    if (this.$route.query.mode !== 'create') {
      this.loadTournament();
    }
    this.loadOrganizerClubs();
  },
  computed: {
    _creatingMode: function() {
      return (this.$route.query.mode == 'create');
    },
    _showManagerAddition: function() {
      return this.showingManagerAddition;      
    },
    showReportDownloadStatus() {
      return this.showingReportDownloadStatus;
    },
    _endDate: {
      get(){
        if (this.tournament.endDate != null)
          return moment(this.tournament.endDate).format('DD-MM-YYYY')
        else return '';
      }
    },
    _startDate: {
      get(){
      if (this.tournament.endDate != null)
        return moment(this.tournament.startDate).format('DD-MM-YYYY');
      else return '';
      }
    },
    _timeControl: {
      get(){
        if (this.tournament.timecontrol == null)
          return -1
        else {
          console.log('timecontrol returned: ' + this.tournament.timecontrol);
          return this.tournament.timecontrol;
        }
      },
      set(newVal){
        this.tournament.timecontrol = newVal;
      }
    },
    _tournamentOrganizer: {
      get(){
        if (this.tournament.clubId == null)
          return 0
        else {
          return this.tournament.clubId;
        }

      },
      set(newVal){
        if (newVal == 0) {
          this.tournament.clubId = null;
        } else
          this.tournament.clubId = newVal;
      }
    },
    _tournamentType: {
      get(){
        if (this.tournament.tournamentTypeId == null)
          return -1
        else {
          console.log('tournamentTypeID returned: ' + this.tournament.tournamentTypeId);
          return this.tournament.tournamentTypeId;
        }
      },
      set(newVal){
        this.tournament.tournamentTypeId = newVal;
      }
    }
  },
  methods: {
    cancel: function() {
      this.$router.go(-2);
    },

    createNewTournament: function() {
      let that = this
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.tournament,
        response: false, 
      };

      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
          that.tournament = response;
          console.log("Tournament created: " + JSON.stringify(that.tournament));
          that.loadSettings();
          that.loadScores();
          that.setTournamentManager(that.$CAUser.getPersonId());
          this.$router.push('/tournaments/' + that.tournament.tournamentId);
        })
        .catch(error => {
          console.log("Error: " + JSON.stringify(error.response));
        });
    },

    downloadReport: function() {
      this.showingReportDownloadStatus = true;
      this.reportDownloading = true;

      const link = document.createElement('a');
      var fileLocation =  process.env.VUE_APP_APIURL;
      link.href = fileLocation + "/Tournament/" 
        + this.tournament.tournamentId + "/report?firstRound="
        + this.firstReportRound + "&lastRound=" + this.lastReportRound;
      link.setAttribute('download', "Titel");
      document.body.appendChild(link);

      console.log("downloading report");
      this.interval = setInterval(() => {
        this.getReportStatus();
      }, 4000); // every 4 seconds

      link.click();
    },

    endDateSelection(newVal) {
      var momentVariable = moment(newVal, 'DD-MM-YYYY');        
      this.tournament.endDate = moment(momentVariable).format('YYYY-MM-DDT00:00:00');
    },
    
    getReportStatus() {
      console.log("report status");

      if (this.reportDownloading) {
        let completePath = "/tournament/" + this.tournament.tournamentId + "/reportStatus";
        let that = this
        const authlInit = { 
          headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
          response: true,
        };
        RestAPI
          .get(apiName, completePath, authlInit)
          .then(response => {
            that.currentReportDownloadStatus = response.data.message;
            if (that.currentReportDownloadStatus.endsWith("Done.")) {
              that.reportDownloading = false;
              clearInterval(this.interval); 
              that.showingReportDownloadStatus = false;
            }
            console.log(JSON.stringify(response));
          })
          .catch(error => {
              if (error.status !== 404) {
              console.log("ERROR", JSON.stringify(error));
            }
          });
      } 
    },

    handleManagerModalResultCancel() {
      console.log('Action canceled');
      this.showingManagerAddition = false;
    },

    handleManagerModalResultOK(person) {
      console.log('Action ok-d with newval:' + JSON.stringify(person));
      this.showingManagerAddition = false;

      //Verwerken nieuwe manager
      this.setTournamentManager(person.personId);
    },
    
    isActiveTab (tabItem) {
      return this.activeTabItem === tabItem;
    },

    loadOrganizerClubs() {
      let completePath = "/club?personId=" + this.$CAUser.getPersonId();
      const myInit = { 
        response: false, 
      };
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          console.log("my clubs: " + JSON.stringify(response));
          this.organizerClubs = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadRounds() {
      let that = this
      let completePath = "/round?tournamentId=" + this.$route.params.tournamentId
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.rounds = response;            
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadSettings: function() {
      let that = this
      let completePath = "/setting?tournamentId=" + this.tournament.tournamentId;
      console.log("loading settings: ", completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.settings = response;
          console.log("Settings loaded: " + JSON.stringify(that.settings));
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadScores: function() {
      let that = this
      let completePath = "/score?tournamentId=" + + this.tournament.tournamentId;
      console.log("loading scores: ", completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.scores = response;
          console.log("Scores loaded: " + JSON.stringify(that.scores));
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadTournament: function() {
      let that = this
      let completePath = path + this.$route.params.tournamentId
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament = response;            
          console.log("Tournament loaded: " + JSON.stringify(that.tournament));
          that.startDateString = moment(this.tournament.startDate).format('DD-MM-YYYY');
          that.loadScores();
          that.loadSettings();
          that.loadRounds();
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    onFilePicked(event) {  
      this.files = event.target.files;
      console.log("file " + JSON.stringify(this.files[0]));
    },

    removeTournamentManager: function(managerId) {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };

      RestAPI
        .del(apiName, "/manager/" + managerId, myInit)
        .then(response => {
          console.log("Manager deleted: " + JSON.stringify(response));
          that.loadTournament(); //reload.
        })
        .catch(error => {
          console.log("Error: " + JSON.stringify(error.response));
        });
    },

    save: function () {
      if (this.$route.query.mode=="edit") 
        this.updateTournament();
      else {
        this.createNewTournament();
      }
    },
    
    setActiveTab (tabItem) {
      this.activeTabItem = tabItem
    },

    scoresChanged() {
      this.scoresDirty = true;
    },

    selectManager() {
      this.showingManagerAddition = true;
    },

    settingsChanged() {
      this.settingsDirty = true;
    },

    setTournamentManager: function(personId) {
      let that = this
      console.log("setTournamentManager this.$CAUser.getPersonId(): " + personId);
      this.manager.personId = personId;
      this.manager.tournamentId = this.tournament.tournamentId;
      this.manager.role = "manager";       
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.manager,
        response: false, 
      };

      RestAPI
        .post(apiName, "/manager/", myInit)
        .then(response => {
          console.log("Manager added: " + JSON.stringify(response));
          that.loadTournament(); //reload.
        })
        .catch(error => {
          console.log("Error: " + JSON.stringify(error.response));
        });
    },

    showDate: function(sDate) {
      return moment(sDate).format("DD MMM yyyy");
    },

    startDateSelection(newVal) {
      var momentVariable = moment(newVal, 'DD-MM-YYYY');        
      this.tournament.startDate = moment(momentVariable).format('YYYY-MM-DDT00:00:00');
    },
    
    updateScores: function () {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.scores,
        response: false, 
      };
      console.log("Scores posting:" + JSON.stringify(this.scores));
      let that = this;

      var completePath = "/score?tournamentid=" + this.tournament.tournamentId;
      console.log("Score url:" + completePath);
      RestAPI
        .put(apiName, completePath, myInit)
        .then( response => {
          console.log("scores updated" + response);
          that.scoresDirty = false;
        }
        )
        .catch(error => {
          console.log("Error: " + error);
        });
    }, 

    updateSettings: function () {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.settings,
        response: false, 
      };
      console.log("Settings posting:" + JSON.stringify(this.settings));
      let that = this;

      var completePath = "/setting?tournamentid=" + this.tournament.tournamentId;
      console.log("Setting url:" + completePath);
      RestAPI
        .put(apiName, completePath, myInit)
        .then(response => {
          console.log("settings updated" + response);
          that.settingsDirty = false;
        }
        )
        .catch(error => {
          console.log("Error: " + error);
        });
    }, 

    updateTournament: function () {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.tournament,
        response: false, 
      };
      var completePath = path + this.tournament.tournamentId;
      RestAPI
        .put(apiName, completePath, myInit)
        .then( response => {
            if (this.settingsDirty)  
              that.updateSettings();
            if (this.scoresDirty)
              that.updateScores();
            console.log("response" + response)
            this.$router.go(-2);
            })
        .catch(error => {
          console.log("Error: " + error);
        });
    },

    uploadKeyfile() {
      const fileReader = new FileReader();
      var keyFile;
      fileReader.onload = e => keyFile = e.target.result;

//      fileReader.addEventListener('load', (e) => {
 //       keyFile = e.target.result
 //     })
      fileReader.readAsDataURL(this.files[0])

      console.log("pgn: " + JSON.stringify(keyFile));
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        file: keyFile,
        response: true, 
      };
      var completePath = "/management/uploadKeyFile?tournamentId=" + this.tournament.tournamentId;
      RestAPI
        .post(apiName, completePath, myInit)
        .then( response => {
            console.log("response" + response)
            })
        .catch(error => {
          console.log("Error: " + error);
        });
    },

    managerIsNotCurrentUser: function(managerId) {
      console.log("comparing '" + managerId + "' to '" + this.$CAUser.getPersonId() + "'")
      return (managerId != this.$CAUser.getPersonId());
    }

  },
}
</script>

<style scoped>

.container {
 width: 100%;
 max-width: 800px;
 margin: 0 auto;
 padding: 1vw;
 box-sizing: border-box;
}

textarea {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  border-radius: 2px;
  box-sizing: border-box;
}

select {
  border-radius: 2px;
  width: 100%;
  height: 26px;
  margin-bottom: 4px;
  box-sizing: border-box;
}

.buttons {
  display: flex;
  flex-direction: row-reverse;
  margin: 2vw;
  flex-wrap: wrap;
}

.sectionButtons {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
}

.expandCol {
  width: auto;
}


.nr {
  width: 80px;
}

.settingsTable {
  width: 100%;
  padding: 0 0 0 2vw;
  box-sizing: border-box;
  overflow-x: auto;
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.section {
  margin: 1vw 2vw;
}

/* mobile */
@media screen and (max-width: 600px) {
  .container {
    width: 98vw;
    max-width: 98vw;
    padding: 2vw;
  }

  .section {
    margin: 1vw 1vw;
  }

  .settingsTable {
    padding: 0 0 0 1vw;
    overflow-x: auto;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .container {
    width: 90vw;
    max-width: 700px;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .container {
    width: 40vw;
    max-width: 800px;
  }
}

</style>
